import React from "react";
import { Link } from "react-router-dom";
import TableColumnAction from "../../shared/entity/TableColumnAction";
import AutomationStatus from "../components/automationStatus";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <Link to={`/clientProjects/${item}`}>#{item}</Link>
            </span>
        ),
        sortable: true,
    },
    {
        field: "clientName",
        name: "Client Name",
        sortable: false,
    },
    {
        field: "name",
        name: "Project Name",
        sortable: false,
    },
    {
        field: "status",
        name: "Status",
        sortable: false,
    },
    {
        field: "numberOfTrucks",
        name: "Number of Trucks",
        sortable: false,
    },
    {
        field: "truckTypes",
        name: "Truck Types",
        sortable: false,
    },
    {
        field: "startDate",
        name: "Started At",
        dataType: "date",
        sortable: false,
    },
    {
        field: "createdAt",
        name: "Creation Date",
        dataType: "date",
        sortable: true,
    },
    {
        field: "updatedAt",
        name: "Update Date",
        dataType: "date",
        sortable: true,
    },
    {
        field: "automationStatus",
        name: "Automation Status",
        render: (item) => <AutomationStatus status={item} />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: TableColumnAction(actions),
    },
];

export default columns;
